import React, { useRef, useEffect, useLayoutEffect, useState } from 'react'
import { mongodb, client, useAuth } from './Auth//use-auth'
import { Link, useHistory, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import DelayingAppearance from './components/DelayingAppearance'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
})

export default function PrintOut (props) {
  var employee = []
  var activity = []
  const classes = useStyles()

  const [joined, setJoined] = useState([])
  const { algus, lopp } = useParams()
  const history = useHistory()
  const mountedRef = useRef(true)
  const { auth, user } = useAuth()
  const [jobs, setJobs] = useState([])
  const [group, setGroup] = useState([])
  const db = mongodb.db('silmandDB')

  const filter = {
    start_time: {
      $gte: Number(moment(Number(algus)).format('x')),
      $lte: Number(moment(Number(lopp)).format('x'))
    }
  }
  const projection = {
    group: 1,
    title: 1,
    start_time: 1,
    end_time: 1,
    clientShortName: 1,
    symptoms: 1
  }
  const groupProjection = {
    _id: 1,
    title: 1
  }

  useEffect(() => {
    let isSubscribed = true
    //
    async function begin () {
      if (isSubscribed) {
        //await listJobs().then(() => loadItems())
        await loadItems()
      }

      console.log('65', activity, employee)
      return () => (isSubscribed = false)
    }
    begin()
    //   if (user) {
    // }
    // return () => {
    //   mountedRef.current = false
    // }
  }, [])

  async function loadItems () {
    //debugger
    try {
      const dbReportD = db.collection('items')
      return await dbReportD
        .find(filter, { projection: projection, sort: { start_time: 1 } })
        .toArray()
        //.then( dataI=>{ activity=dataI})
        .then(dataI => {
          mapJobs(dataI)
        })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      //joinedArray(activity, employee)
      console.log('89', activity, employee)
    }
  }
  function mapJobs (dataI) {
    try {
      dataI.map(jobData => {
        activity.push({
          id: jobData.group,
          title: jobData.title,
          start_time: jobData.start_time,
          end_time: jobData.end_time,

          clientShortName: jobData.clientShortName,
          symptoms: jobData.symptoms
        })
        listJobs(jobData.group)

        return true
      })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      console.log('115', activity, employee)
    }

    //return joinedArray(jobs, group)
  }
  async function listJobs (workerId) {
    //debugger
    const dbGroups = db.collection('groups')
    const cursor = dbGroups

    await cursor
      .find({ _id: workerId }, { projection: groupProjection })
      .toArray()
      .then(data => {
        displayReport(data)
        joinedArray(activity, employee)
      })

    //setGroup(prevdat=>[...prevdat,{...employee}])
    // console.log('employee',workerId);
  }
  const displayReport = paramGroups => {
    // debugger
    //setGroup(prevGroup => [...prevGroup, ...paramGroups])

    paramGroups.map(data => {
      employee.push({
        id: data._id,
        nimi: data.title
      })
    })

    return
  }

  function joinedArray (jobs1 = activity, group1 = employee) {
    console.log('activity', jobs1)
    console.log('employee', group1)
    const a3 = jobs1.map(t1 => ({
      ...t1,
      ...group1.find(t2 => t2.id === t1.id)
    }))
    setJobs(...jobs, [...Array.from(a3)])
  }

  return (
    <React.Fragment>
      <Grid container spacing={50}>
        <Grid item xs={2} sm={2}>
          <Link to={`/printquery`}>Tagasi valikusse</Link>
        </Grid>
        <Grid item xs={2} sm={2}>
          Alates {moment(Number(algus)).format('DD.MM.YY')} kuni{' '}
          {moment(Number(lopp)).format('DD.MM.YY')}
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table
          stickyHeader
          aria-label='sticky table'
          size='small'
          className={classes.table}
        >
          <TableHead>
            <TableRow selected={true} hover={true}>
              <TableCell align='left'>Kuup</TableCell>
              <TableCell align='left'>Nimi</TableCell>
              <TableCell align='left'>Selgitus</TableCell>
              <TableCell align='left'>Klient</TableCell>
              <TableCell align='left'>Põhjus</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jobs.map((row, index) => (
              <TableRow key={index}>
                <TableCell align='left'>
                  {moment(row.start_time).format('DD.MM')}
                </TableCell>
                <TableCell align='left'>{row.nimi}</TableCell>
                <TableCell align='left'>{row.title}</TableCell>
                <TableCell align='left'>{row.clientShortName}</TableCell>
                <TableCell align='left'>{row.symptoms}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  )
}
// { JSON.stringify(jobs, '', 2) }
// { JSON.stringify(group, '', 2) }
// { JSON.stringify(joined, '', 2) }
